export default function capitalize(str) {
  const wordsArray = str.toLowerCase().split(' ');
  const capsArray = wordsArray.map(word => {
    return word[0].toUpperCase() + word.slice(1);
  });
  return capsArray.join(' ');
}
